import { TextField, Grid, IconButton, Typography, Stack, Box, Chip, Autocomplete } from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

export default function VentaItemRow({ item, index, total, productos, moneda, onChange, onProductPick, onRemove, canRemove }) {
  const subtotal = (parseFloat(item.precioUnitario) || 0) * (parseInt(item.cantidad) || 1);
  const productoSel = item.productoId ? productos.find((p) => p.id === item.productoId) || null : null;

  return (
    <Box
      sx={{
        p: 1.5,
        borderRadius: 2,
        bgcolor: "grey.50",
        border: 1,
        borderColor: "grey.200",
        position: "relative",
        "&:hover": { borderColor: "primary.light", bgcolor: "grey.50" },
        transition: "border-color 0.15s",
      }}
    >
      {canRemove && (
        <IconButton
          size="small"
          color="error"
          onClick={() => onRemove(index)}
          sx={{ position: "absolute", top: 4, right: 4, bgcolor: "error.50", "&:hover": { bgcolor: "error.100" } }}
        >
          <RemoveCircleOutlineIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}

      {total > 1 && (
        <Chip label={`#${index + 1}`} size="small" sx={{ fontSize: 10, height: 18, mb: 1, fontWeight: 700 }} />
      )}

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={6}>
          {productos.length > 0 ? (
            <>
              <Autocomplete
                options={productos}
                value={productoSel}
                onChange={(_, prod) => onProductPick(index, prod)}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                getOptionLabel={(p) => `${p.nombre} — ${moneda} ${p.precio}`}
                filterOptions={(options, { inputValue }) => {
                  const q = inputValue.trim().toLowerCase();
                  if (!q) return options;
                  return options.filter((p) => p.nombre?.toLowerCase().includes(q));
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Producto / Servicio" size="small" placeholder="Buscar en catálogo" />
                )}
                noOptionsText="Sin coincidencias — personalizado abajo"
              />
              {!item.productoId && (
                <TextField
                  label="Nombre personalizado"
                  value={item.productoNombre}
                  onChange={onChange(index, "productoNombre")}
                  fullWidth
                  size="small"
                  required
                  sx={{ mt: 1 }}
                />
              )}
            </>
          ) : (
            <TextField
              label="Producto / Servicio personalizado"
              value={item.productoNombre}
              onChange={onChange(index, "productoNombre")}
              fullWidth
              size="small"
              placeholder="Nombre del producto"
            />
          )}
        </Grid>
        <Grid item xs={4} sm={2}>
          <TextField
            label="Cant."
            value={item.cantidad}
            onChange={onChange(index, "cantidad")}
            type="number"
            inputProps={{ min: 1 }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={8} sm={4}>
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              label="Precio unit."
              value={item.precioUnitario}
              onChange={onChange(index, "precioUnitario")}
              type="number"
              inputProps={{ min: 0, step: "0.01" }}
              fullWidth
              size="small"
            />
            {subtotal > 0 && (
              <Typography variant="body2" fontWeight={700} color="success.main" noWrap sx={{ minWidth: 60, textAlign: "right" }}>
                = {subtotal.toLocaleString()}
              </Typography>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
